export class LookupElementModel {
    id;
    value;
    comment = '';
    expirationTime;
}
export const LookupElementExportFields = ['id', 'value', 'comment', 'expirationTime'];
//# sourceMappingURL=lookup-element.js.map